export const STATUS = {
  draft: {
    text: "#374151",
    bg: "default",
    border: "#d1d5db",
  },
  approved: {
    text: "#166534",
    bg: "green",
    border: "#86efac",
  },
  requested: {
    text: "#1d4ed8",
    bg: "blue",
    border: "#93c5fd",
  },
  scheduled: {
    text: "#92400e",
    bg: "gold",
    border: "#fcd34d",
  },
  published: {
    text: "#0e7490",
    bg: "cyan",
    border: "#67e8f9",
  },
  rejected: {
    text: "#991b1b",
    bg: "red",
    border: "#fca5a5",
  },
  pending: {
    text: "#92400e",
    bg: "gold",
    border: "#fcd34d",
  },
  completed: {
    text: "#166534",
    bg: "green",
    border: "#86efac",
  },
  archived: {
    text: "#374151",
    bg: "default",
    border: "#d1d5db",
  },
} as const;
